module.exports = __webpack_public_path__ + "static/media/handOk.f5cfbd89.svg";